import React from 'react';
import styled from 'styled-components';
import Body from 'components/common/body';
import List, { ListProps } from 'components/common/list';

const LI = styled.li`
  width: 100%;
  padding-right: 20px;
`;

type BlogPostListProps = ListProps;

const BlogPostList = ({ children, ...rest }: BlogPostListProps) => {
  return (
    <List {...rest}>
      {children.map((child, idx) => (
        <Body>
          <LI key={idx}>{child}</LI>
        </Body>
      ))}
    </List>
  );
};

export default BlogPostList;
